// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_promise from "../../../../../../../node_modules/rescript/lib/es6/js_promise.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.mjs";
import * as CountryHelpers$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/helpers/CountryHelpers.mjs";
import * as PartnersDataSource$PorterinFeature from "../data-source/PartnersDataSource.mjs";
import * as PartnersRepoConfig$PorterinFeature from "./PartnersRepoConfig.mjs";
import * as Network$PorterinFusionkitNetworkUtils from "../../../../../../../node_modules/@porterin/fusionkit-network-utils/src/Network.mjs";
import * as ApiUtils$PorterinFusionkitNetworkUtils from "../../../../../../../node_modules/@porterin/fusionkit-network-utils/src/ApiUtils.mjs";

function getMainPageContent(locale) {
  var country = CountryHelpers$PorterinUtils.countryCodeFromLocale(locale);
  var requestUrl = PartnersDataSource$PorterinFeature.getPartnersCMSUrl(country, locale);
  return Js_promise.then_((function (result) {
                return ApiUtils$PorterinFusionkitNetworkUtils.resolveRepoResponse(function (param) {
                            return Curry._1(PartnersRepoConfig$PorterinFeature.PartnersContentApiResponseConverter.execute, result);
                          });
              }), Network$PorterinFusionkitNetworkUtils.getRequestV2(requestUrl, undefined, undefined, undefined));
}

function fetchPartnerVehicles(geo_region_id) {
  var requestUrl = PartnersDataSource$PorterinFeature.getPartnerVehiclesRequestUrl(geo_region_id);
  return Js_promise.then_((function (result) {
                return Js_promise.then_((function (result) {
                              if (result.TAG === /* Ok */0) {
                                return Promise.resolve({
                                            TAG: /* Ok */0,
                                            _0: result._0
                                          });
                              }
                              var catalystError = /* DefaultError */{
                                _0: {
                                  title: /* Unauthorized */1,
                                  message: result._0._0.message
                                }
                              };
                              return Promise.resolve({
                                          TAG: /* Error */1,
                                          _0: catalystError
                                        });
                            }), ApiUtils$PorterinFusionkitNetworkUtils.resolveRepoResponse(function (param) {
                                return Curry._1(PartnersRepoConfig$PorterinFeature.PartnerVehiclesApiResponseConverter.execute, result);
                              }));
              }), Network$PorterinFusionkitNetworkUtils.getRequestV2(requestUrl, undefined, undefined, undefined));
}

function submitAttachVehicleForm(form) {
  var match = PartnersDataSource$PorterinFeature.getSubmitVehicleFormUrlAndPayload(form);
  return Js_promise.then_((function (result) {
                return Js_promise.then_((function (result) {
                              if (result.TAG === /* Ok */0) {
                                return Promise.resolve({
                                            TAG: /* Ok */0,
                                            _0: result._0
                                          });
                              } else {
                                return Promise.resolve({
                                            TAG: /* Error */1,
                                            _0: ErrorUtils$Catalyst.getDefaultErrorEntity("Failed to submit form", undefined, undefined)
                                          });
                              }
                            }), ApiUtils$PorterinFusionkitNetworkUtils.resolveRepoResponse(function (param) {
                                return Curry._1(PartnersRepoConfig$PorterinFeature.PartnerFormApiResponseConverter.execute, result);
                              }));
              }), Network$PorterinFusionkitNetworkUtils.postRequestV2(match[0], match[1], {
                  "Content-Type": "application/json"
                }, undefined, undefined));
}

export {
  getMainPageContent ,
  fetchPartnerVehicles ,
  submitAttachVehicleForm ,
}
/* PartnersDataSource-PorterinFeature Not a pure module */
